<template>
  <div>
    <tweet-button v-if="graphId && graphTitle" :shareMessage="shareMessage" :shareUrl="shareUrl" :graphId="graphId" :drawType="drawType" :collateGraphId="collateGraphId"/>
    <tweet-copy-area v-if="shareUrl" :shareMessage="shareMessage" :shareUrl="shareUrl" />
  </div>
</template>

<script>
import TweetButton from "@/components/TweetButton.vue";
import TweetCopyArea from "@/components/TweetCopyArea.vue";
import { decode } from 'punycode';

export default {
  props: {
    graphTitle: {
      type: String,
      default: ""
    },
    graphId: {
      type: Number,
      default: 0
    },
    isTemplate: {
      type: Boolean,
      default: false
    },
    isCollate: {
      type: Boolean,
      default: false
    },
    collateGraphId: {
      type: Number,
      default: 0
    }
  },
  components: {
    TweetButton,
    TweetCopyArea
  },
  data() {
    return {
      shareMessage: "",
      shareUrl: "",
      drawType: ""
    };
  },
  computed: {
    getTemplate() {
      return this.isTemplate;
    },
    getCollate() {
      return this.isCollate;
    }
  },
  watch: {
    graphId: function() {
      this.setShareUrl();
    },
    graphTitle: function() {
      this.setShareMessage();
    },
    getTemplate() {
      this.setDrawType();
    },
    getCollate() {
      this.setDrawType();
    }
  },
  created() {
    this.setDrawType();
  },
  methods: {
    setShareUrl() {
      this.shareUrl = location.origin + "/graph/" + this.graphId;
    },
    setShareMessage() {
      this.shareMessage = 'emooooできもちを共有したよ。さっそく見に行ってみよう！「' + this.graphTitle + '」';
    },
    setDrawType() {
      this.drawType = "edit";

      if(this.isTemplate) {
        this.drawType = "template";
      }
      if(this.isCollate) {
        this.drawType = "overwrite";
      }
    }
  }
}
</script>

<style scoped lang="scss">
div {
  text-align: center;
}
</style>